<template>
  <div class="content">
    <!-- 🌀 Loader -->
    <transition name="fade-slide">
      <div v-if="loading" class="global-loader">
        <div class="loader-spinner"></div>
        <p>Loading ...</p>
      </div>
    </transition>


    <!-- ✅ Delete Confirmation Modal -->
    <div v-if="confirmBox.show" class="confirm-dialog-backdrop">
      <div class="confirm-dialog">
        <i class="bx bx-error-circle"></i>
        <h3>Delete!!</h3>
        <p>Are you sure you want to delete <b>{{
            (activeFilter1==="bookings")?confirmBox.item?.website_title:confirmBox.item?.profile_username }}</b>?</p>
        <div class="confirm-actions">
          <button class="btn-secondary" @click="closeConfirm">Cancel</button>
          <button class="btn-danger" @click="deleteConfirmed">Delete</button>
        </div>
      </div>
    </div>

    <!-- ✅ KPI Cards -->
    <div class="kpi-summary">
      <div class="kpi-item" v-for="card in kpiCards" :key="card.title">
        <div class="kpi-info">
          <h4>{{ card.title }}</h4>
          <div class="value">{{ card.value }}</div>
        </div>
        <i :class="card.icon + ' kpi-icon'"></i>
      </div>
    </div>

    <!-- ✅ Search & Add -->
    <div class="filter-row">
      <div class="search-box">
        <i class="bx bx-search"></i>
        <input type="text" placeholder="Search pages..." v-model="searchQuery" @input="debouncedSearch" />
      </div>
      <!-- <div class="filter-buttons">
        <button :class="['filter-btn', activeFilter1 === 'pages' ? 'active' : '']" @click="switchType('pages')">
          Pages
        </button>
        <button :class="['filter-btn', activeFilter1 === 'websites' ? 'active' : '']" @click="switchType('websites')">
          Websites
        </button>
      </div> -->

      <button class="btn-primary" @click="createNewWebsite">
        <i class="bx bx-plus"></i> {{(activeFilter1==="bookings")?"Create New":"Create New"}}
      </button>
    </div>

    <!-- ✅ Website Grid -->
    <!-- <div v-if="bookings.length > 0 && activeFilter1==='websites'" class="website-grid">
      <div class="website-card fade-in" v-for="booking in bookings" :key="booking.website_id">
        <div class="website-card-header">
          <h4><i class="bx bx-globe"></i> {{ booking.website_title }}</h4>

          <button class="btn-copy" @click="toggleWebNow(booking.website_id)">
            <i v-if="booking.website_status==='Pending'" class="bx bx-cloud-upload"></i>
            <i v-if="booking.website_status==='Live'" class="bx bx-block"></i>
            <span v-if="booking.website_status==='Pending'">Publish</span>
            <span v-if="booking.website_status==='Live'">Unpublish</span>
          </button>
        </div>

        <div class="website-card-body">
          <div style="display: flex; align-items: center;">
            <p>{{ booking.website_desc || 'No description available.' }}</p>
           
          </div>
          <div class="website-stats-grid">
            <div class="stat-item">
              <i class="bx bx-show stat-icon"></i>
              <span>Visitors</span>
              <strong>{{ booking.visitors }}</strong>
            </div>
            <div class="stat-item">
              <i class="bx bx-user stat-icon"></i>
              <span>Leads</span>
              <strong>{{ booking.leads }}</strong>
            </div>
          </div>

          <div class="website-stats-grid">
            <div class="stat-item">
              <i class="bx bx-calendar-check stat-icon"></i>
              <span>Bookings</span>
              <strong>{{ booking.bookings }}</strong>
            </div>
            <div class="stat-item">
              <i class="bx bx-dollar-circle stat-icon"></i>
              <span>Revenue</span>
              <strong>${{ booking.revenue }}</strong>
            </div>
          </div>
        </div>

        <div class="website-card-footer">
          <div class="domain-wrapper">
            <span class="website-domain">
              <i class="bx bx-globe"></i>
              <a v-if="booking.website_page && booking.website_domain_status==='Connected'" :href="'https://'+booking.website_domain" target="_blank">{{
                booking.website_domain }}</a>
                <a v-if="booking.website_page && booking.website_domain_status!='Connected'" :href="base_url+booking.website_page" target="_blank">{{
                booking.website_domain }}</a>
              <span v-if="!booking.website_page">{{ booking.website_domain }}</span>

            </span>
            <div class="domain-status" :class="booking.website_domain_status === 'Connected' ? 'connected' : 'pending'"
              :style="{
    color:
      booking.website_domain_status === 'Connected'
        ? '#16A34A'   // green
        : '#F59E0B',  // amber
  }">
              <i class="bx" :class="
      booking.website_domain_status === 'Connected'
        ? 'bx-check-circle'
        : 'bx-time-five'
    " :style="{
      marginRight: '4px',
      color:
        booking.website_domain_status === 'Connected'
          ? '#16A34A'
          : '#F59E0B',
    }"></i>
              <span>{{ booking.website_domain_status }}</span>
            </div>

          </div>

          <div class="website-actions flex gap-2">
            
            <button class="btn-copy" @click="editBooking1(booking)">
              <i class="bx bx-globe text-sm" style="color: #fff;"></i>
              Theme Settings
            </button>

            <button class="btn-copy" @click="editBooking(booking)">
              <i class="bx bx-edit text-sm" style="color: #fff;"></i>
              Edit
            </button>

            <i class="bx bx-trash" @click="showConfirm(booking)"></i>
          </div>

        </div>
      </div>
    </div> -->
    <div v-if="bookings.length > 0 && activeFilter1==='pages'" class="website-grid">
      <div class="website-card fade-in" v-for="booking in bookings" :key="booking.profile_id">
        <div class="website-card-header">
          <h4><i class="bx bx-globe"></i> {{ booking.profile_username }}</h4>


        </div>

        <div class="website-card-body">
          <div style="display: flex; align-items: center;">
            <p>{{ booking.profile_shortdesc || 'No description available.' }}</p>
            <!-- &nbsp;&nbsp;&nbsp;
            <span class="website-status" :class="booking.website_status.toLowerCase()">
              {{ booking.website_status }}
            </span> -->
          </div>
          <div class="website-stats-grid">
            <div class="stat-item">
              <i class="bx bx-show stat-icon"></i>
              <span>Visitors</span>
              <strong>{{ booking.visitors }}</strong>
            </div>
            <div class="stat-item">
              <i class="bx bx-user stat-icon"></i>
              <span>Leads</span>
              <strong>{{ booking.leads }}</strong>
            </div>
          </div>

          <div class="website-stats-grid">
            <div class="stat-item">
              <i class="bx bx-calendar-check stat-icon"></i>
              <span>Packages</span>
              <strong>{{ booking.comments }}</strong>
            </div>
            <div class="stat-item">
              <i class="bx bx-dollar-circle stat-icon"></i>
              <span>UGC Items</span>
              <strong>{{ booking.ugcitems }}</strong>
            </div>
          </div>
        </div>

        <div class="website-card-footer">
          <div class="domain-wrapper">
            <span class="website-domain">
              <i class="bx bx-globe"></i>
              <a :href="base_url1+'new_single_web/'+booking.profile_username" target="_blank">
                /{{booking.profile_username }}
              </a>

            </span>
            <div class="domain-status" :class="booking.profile_status === 'Live' ? 'Live' : 'pending'" :style="{
    color:
      booking.profile_status === 'Live'
        ? '#16A34A'   // green
        : '#F59E0B',  // amber
  }">
              <i class="bx" :class="
      booking.profile_status === 'Live'
        ? 'bx-check-circle'
        : 'bx-time-five'
    " :style="{
      marginRight: '4px',
      color:
        booking.profile_status === 'Live'
          ? '#16A34A'
          : '#F59E0B',
    }"></i>
              <span>{{ booking.profile_status }}</span>
            </div>
          </div>
          <div class="website-actions">
            <button class="btn-copy" @click="editBooking(booking)">
              <i class="bx bx-edit text-sm" style="color: #fff;"></i>
              Edit
            </button>
            <i class="bx bx-trash" @click="showConfirm(booking)"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- 🧩 EMPTY STATE PLACEHOLDER -->
    <div v-else-if="!loading && bookings.length<=0" class="empty-state"
      style="text-align:center; display:flex; flex-direction:column; align-items:center; justify-content:center;">
      <i class="bx bx-folder-open"></i>
      <h3>No Pages Found</h3>
      <p>You haven’t created any pages yet. Let’s set up your first one.</p>
      <button class="btn-primary" @click="createNewWebsite"
        style="padding: 8px 14px; font-size: 13px; border-radius: 6px;">
        <i class="bx bx-plus" style="font-size: 14px; color: white; margin-top: .7rem;"></i> Create New Page
      </button>
    </div>

    <!-- ✅ Pagination -->
    <div class="pagination-row" v-if="totalRecords > 0">
      <span class="pagination-info">
        Showing {{ startIndex + 1 }}–{{ endIndex }} of {{ totalRecords }} results
      </span>

      <div class="pagination-buttons">
        <button :disabled="currentPage === 1" @click="prevPage">
          <i class="bx bx-chevron-left"></i>
        </button>
        <button v-for="page in totalPages" :key="page" @click="goToPage(page)"
          :class="{ active: currentPage === page }">
          {{ page }}
        </button>
        <button :disabled="currentPage === totalPages" @click="nextPage">
          <i class="bx bx-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- ADD PAGE POPUP -->
    <div v-if="showAddPagePopup" class="modal-overlay">
      <div class="modal-box">

        <h3>Let’s setup your card</h3>

        <label class="field-label">Card Username</label>
        <!-- <input type="text" class="input-theme" v-model="username" placeholder="Enter card username" /> -->
         <input
            type="text"
            class="input-theme"
            v-model="username"
            placeholder="Enter card username"
            @keydown.space.prevent
          />

        <div class="modal-actions">
          <button class="btn-secondary" @click="showAddPagePopup = false">Cancel</button>
          <button class="btn-primary" @click="saveNewPage">
            <i class="bx bx-check"></i> Create Card
          </button>
        </div>

      </div>
    </div>
    <div v-if="showModeModal" class="mode-modal">
      <div class="mode-modal-content animate-popup" style="position: relative;">

        <!-- Close Icon -->
        <div style="position:absolute; top:12px; left:12px; cursor:pointer; z-index:20;
             width:30px; height:30px; border-radius:50%; background:#000;
             display:flex; align-items:center; justify-content:center;
             font-size:20px; color:#fff;" @click="showModeModal = false">
          <i class='bx bx-x'></i>
        </div>
        <!-- /Close Icon -->

        <h3 class="modal-title">Choose How You Want to Build</h3>
        <p class="modal-desc">
          Select your preferred mode to start building your website.
        </p>

        <div class="mode-selection-horizontal">

          <!-- Instant Website (Left) -->
          <div class="mode-card selectable" @click="selectMode('pages')">
            <div class="icon-box"><i class="bx bx-bolt-circle"></i></div>
            <h5>Instant Website</h5>
            <p>
              Create Your Website in a Few Clicks and Get Brands
            </p>
          </div>

          <!-- Detailed Wizard (Right) -->
          <div class="mode-card premium selectable" @click="selectMode('websites')">
            <div class="icon-box"><i class="bx bx-layer-plus"></i></div>
            <h5>
              Detailed Website <span class="badge-pro">Pro</span>
            </h5>
            <p>
              Get Online Presence For Your Business in a Few Steps
            </p>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  // import { getWebReport, getWebsites, deleteWebsite, webToggle } from "@/apis/webapis";
  import { getProfiles, getProReport, deleteProfile, createPage } from "@/apis/profileapi";
  import { apiBaseUrl, mainBaseUrl } from "@/apis/appconst";
  import debounce from "lodash.debounce";
  import { useToast } from "vue-toastification";

  export default {
    name: "MyWebsites",
    data() {
      return {
        showModeModal: false,
        userId: null,
        toast: useToast(),
        showAddPagePopup: false,
        username: "",
        base_url: "",
        base_url1: "",
        kpiCards: [
          { title: "Total Websites", value: 0, icon: "bx bx-globe" },
          { title: "Visitors", value: 0, icon: "bx bx-show" },
          { title: "Leads", value: 0, icon: "bx bx-user-plus" },
          { title: "Bookings", value: 0, icon: "bx bx-calendar" },
          { title: "Revenue", value: "$0", icon: "bx bx-dollar-circle" },
        ],
        bookings: [],
        searchQuery: "",
        activeFilter1: "pages",
        loading: false,
        currentPage: 1,
        perPage: 10,
        totalRecords: 0,
        confirmBox: { show: false, item: null },
      };
    },

    computed: {
      totalPages() {
        return Math.ceil(this.totalRecords / this.perPage);
      },
      startIndex() {
        return (this.currentPage - 1) * this.perPage;
      },
      endIndex() {
        return Math.min(this.startIndex + this.bookings.length, this.totalRecords);
      },
    },

    methods: {
      selectMode(selected) {
        this.showModeModal = false;
        this.activeFilter1 = selected;
        // if (this.activeFilter1 === "websites") {
        //   sessionStorage.removeItem("website_id");
        //   window.location.href = "/new_website";
        // }
        // else {
        this.username = "";
        this.showAddPagePopup = true;
        // }
      },
      switchType(type) {
        this.activeFilter1 = type;
        this.loadWebsites();
        this.loadKPIs();
      },


      async loadKPIs() {
        try {
          // if (this.activeFilter1 === "websites") {

          //   this.kpiCards = [
          //     { title: "Total Websites", value: 0, icon: "bx bx-globe" },
          //     { title: "Visitors", value: 0, icon: "bx bx-show" },
          //     { title: "Leads", value: 0, icon: "bx bx-user-plus" },
          //     { title: "Bookings", value: 0, icon: "bx bx-calendar" },
          //     { title: "Revenue", value: "$0", icon: "bx bx-dollar-circle" },
          //   ];
          //   const res = await getWebReport(this.userId);
          //   if (res?.status) {
          //     this.kpiCards[0].value = res.total_websites || 0;
          //     this.kpiCards[1].value = res.visitors || 0;
          //     this.kpiCards[2].value = res.leads || 0;
          //     this.kpiCards[3].value = res.bookings || 0;
          //     this.kpiCards[4].value = "$" + (res.revenue || 0);
          //   }
          // }
          // else {
          this.kpiCards = [
            { title: "Total Pages", value: 0, icon: "bx bx-globe" },
            { title: "Visitors", value: 0, icon: "bx bx-show" },
            { title: "Leads", value: 0, icon: "bx bx-user-plus" },
            { title: "Packages", value: 0, icon: "bx bx-calendar" },
          ];
          const res = await getProReport(this.userId);
          if (res?.status) {
            this.kpiCards[0].value = res.total_websites || 0;
            this.kpiCards[1].value = res.visitors || 0;
            this.kpiCards[2].value = res.leads || 0;
            this.kpiCards[3].value = res.comments || 0;
          }
          // }
        } catch (err) {
          console.error("KPI Error:", err);
        }
      },

      showToast(msg, type) {
        if (type === "danger") {
          this.toast.error(msg + "");
        }
        else {
          this.toast.success(msg + "");
        }
      },
      async loadWebsites(page = 1) {
        this.loading = true;
        // if (this.activeFilter1 === "websites") {
        //   try {
        //     const res = await getWebsites(this.userId, (page - 1) + "", "", this.searchQuery);
        //     if (res?.status) {
        //       this.bookings = res.records || [];
        //       this.totalRecords = res.total1 || this.bookings.length;
        //     } else {
        //       this.bookings = [];
        //       this.showToast(res?.success || "Failed to load websites", "danger");
        //     }
        //   } catch (err) {
        //     console.error("Website Load Error:", err);
        //     this.showToast("Server error while loading websites", "danger");
        //   } finally {
        //     this.loading = false;
        //   }
        // }
        // else {
        try {
          const res = await getProfiles(this.userId, (page - 1) + "", this.searchQuery);
          if (res?.status) {
            this.bookings = res.records || [];
            this.totalRecords = res.total || this.bookings.length;
          } else {
            this.bookings = [];
            this.showToast(res?.success || "Failed to load pages", "danger");
          }
        } catch (err) {
          console.error("Website Load Error:", err);
          this.showToast("Server error while loading pages", "danger");
        } finally {
          this.loading = false;
        }
        // }
      },
      // async toggleWebNow(webId) {
      //   this.loading = true;
      //   try {
      //     const res = await webToggle(webId);
      //     if (res?.status) {
      //       this.loadWebsites(1);
      //     }
      //   } catch (err) {
      //     console.error("Website Load Error:", err);
      //   } finally {
      //     this.loading = false;
      //   }
      // },

      showConfirm(item) {
        this.confirmBox.show = true;
        this.confirmBox.item = item;
      },

      closeConfirm() {
        this.confirmBox.show = false;
        this.confirmBox.item = null;
      },

      async deleteConfirmed() {
        const booking = this.confirmBox.item;
        this.closeConfirm();
        if (!booking) return;

        this.loading = true;
        try {
          // if (this.activeFilter1 === "websites") {
          //   const res = await deleteWebsite(booking.website_id);
          //   if (res?.status) {
          //     this.showToast("Deleted successfully", "success");
          //     await this.loadWebsites(this.currentPage);
          //   } else {
          //     this.showToast(res?.success || "Delete failed", "danger");
          //   }
          // }
          // else {
          const res = await deleteProfile(booking.profile_id);
          if (res?.status) {
            this.showToast("Deleted successfully", "success");
            await this.loadWebsites(this.currentPage);
          } else {
            this.showToast(res?.success || "Delete failed", "danger");
          }
          // }

        } catch (err) {
          console.error("Delete Error:", err);
          this.showToast("Server error while deleting", "danger");
        } finally {
          this.loading = false;
        }
      },

      createNewWebsite() {
        // this.showModeModal = true;
        this.selectMode('pages');
      },
      async saveNewPage() {
        try {
          if (!this.username.trim()) {
            this.showToast("Please enter username", "danger");
            return;
          }
          this.loading = true;
          this.showAddPagePopup = false;
          const res = await createPage(this.userId, this.username, Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata");
          this.loading = false;
          if (res?.status) {
            var pid = res.profile_dt.profile_username;
            window.location.href = "/new_single_web/" + pid + "?edit=1";
          } else {
            this.showAddPagePopup = true;
            this.showToast(res?.success || "Failed", "danger");
          }
        } catch (err) {
          console.error("Website Load Error:", err);
          this.showToast("Server error", "danger");
        } finally {
          this.loading = false;
        }
      },

      async nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          await this.loadWebsites(this.currentPage);
        }
      },

      async prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          await this.loadWebsites(this.currentPage);
        }
      },

      async goToPage(page) {
        this.currentPage = page;
        await this.loadWebsites(this.currentPage);
      },

      editBooking(b) {
        // if (this.activeFilter1 === "websites") {
        //   sessionStorage.setItem("website_id", JSON.stringify(b));
        //   window.location.href = `/new_website`;
        // }
        // else {
        window.location.href = `/new_single_web/` + b.profile_username + "?edit=1";
        // }
      },
      editBooking1(b) {
        window.location.href = "/web_editor/" + b.website_id;
      },

      async debouncedSearch() {
        this.currentPage = 1;
        this.debouncedLoad();
      },
    },

    created() {
      this.debouncedLoad = debounce(() => this.loadWebsites(this.currentPage), 600);
    },

    async mounted() {

      this.base_url = apiBaseUrl;
      this.base_url1 = mainBaseUrl;
      const ldataRaw = sessionStorage.getItem("ldata");
      const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
      if (!ldata) {
        window.location.href = "/login";
        return;
      }

      this.userId = ldata.user_id;
      await this.loadKPIs();
      await this.loadWebsites();
    },
  };
</script>

<style scoped>
  /* =========================================
   🔹 MODALS (MODE SELECTION & SAVE)
   ========================================= */
  .mode-modal {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    animation: fadeIn 0.3s ease;
  }

  .mode-modal-content {
    background: #fff;
    border-radius: 1.2rem;
    width: 100%;
    max-width: 540px;
    padding: 2rem;
    text-align: center;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    animation: slideUp 0.4s ease;
  }

  .mode-modal-content h3 {
    font-weight: 700;
    font-size: 1.4rem;
    color: #111827;
    margin-bottom: 0.4rem;
  }

  .mode-modal-content p {
    color: #6b7280;
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }


  /* ===============================
   🔹 POPUP MODAL BASE
   =============================== */
  .mode-modal {
    position: fixed;
    inset: 0;
    backdrop-filter: blur(6px);
    display: flex;
    align-items: start;
    padding-top: 5rem;
    justify-content: center;
    z-index: 100;
    animation: fadeIn 0.3s ease;
  }

  .mode-modal-content {
    background: #fff;
    border-radius: 1.2rem;
    width: 100%;
    max-width: 800px;
    padding: 2.2rem 2.5rem;
    text-align: center;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
    animation: slideUp 0.4s ease;
  }

  .mode-modal-content .modal-title {
    font-weight: 700;
    font-size: 1.4rem;
    color: #111827;
    margin-bottom: 0.4rem;
  }

  .mode-modal-content .modal-desc {
    color: #6b7280;
    font-size: 0.9rem;
    margin-bottom: 2rem;
  }

  /* ===============================
   🔹 HORIZONTAL CARD ALIGNMENT
   =============================== */
  .mode-selection-horizontal {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 1.5rem;
  }

  .mode-card {
    flex: 1;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 1rem;
    padding: 1.8rem 1.5rem;
    text-align: center;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    cursor: pointer;
  }

  .mode-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  }

  .mode-card .icon-box {
    font-size: 2.4rem;
    color: #111827;
    margin-bottom: 0.8rem;
    transition: transform 0.3s ease;
  }

  .mode-card:hover .icon-box {
    transform: scale(1.1);
  }

  .mode-card h5 {
    font-weight: 600;
    font-size: 1.05rem;
    color: #111827;
    margin-bottom: 0.5rem;
  }

  .mode-card p {
    font-size: 0.9rem;
    color: #6b7280;
    line-height: 1.5;
  }

  .mode-card.premium {
    border: 2px dashed #c7d2fe;
  }

  .badge-pro {
    background: #fcd34d;
    color: #111827;
    font-size: 0.7rem;
    font-weight: 600;
    padding: 0.2rem 0.5rem;
    border-radius: 0.4rem;
    margin-left: 0.3rem;
  }


  .filter-buttons {
    width: 60%;
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
  }

  .filter-btn {
    background: #f3f4f6;
    border: none;
    padding: 6px 14px;
    border-radius: 6px;
    font-size: 13px;
    cursor: pointer;
    transition: 0.25s ease;
    white-space: nowrap;
    /* keep in one line */
  }

  .filter-btn.active {
    background: var(--primary);
    color: #fff;
  }

  @media (max-width: 480px) {
    .filter-buttons {
      overflow-x: auto;
      /* horizontal scroll for small phones */
      white-space: nowrap;
      display: flex;
      gap: 10px;
      padding-bottom: 4px;
    }
  }

  .kpi-summary {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
  }

  .kpi-item {
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.25s ease;
  }

  .kpi-item:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  }

  .kpi-info h4 {
    color: var(--muted);
    font-size: 13px;
    margin-bottom: 4px;
  }

  .kpi-info .value {
    font-weight: 700;
    font-size: 18px;
    color: var(--text);
  }

  .filter-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }

  .pagination-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding-top: 14px;
    border-top: 1px solid var(--border);
    flex-wrap: wrap;
    gap: 10px;
  }

  .pagination-buttons button {
    background: #f3f4f6;
    color: var(--text);
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .pagination-buttons button.active {
    background: var(--primary);
    color: #fff;
    font-weight: 600;
  }

  .pagination-buttons button:hover:not(.active) {
    background: #e5e7eb;
  }

  .website-status.active {
    background: #e0e7ff;
    color: #111827;
  }

  .website-status.pending {
    background: #fef3c7;
    color: #92400e;
  }

  .website-status.completed {
    background: #dcfce7;
    color: #166534;
  }

  /* Subtle fade-in */
  .fade-in {
    animation: fadeIn 0.4s ease both;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .website-stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 10px;
    margin-top: 10px;
  }

  .stat-item {
    background: #f9fafb;
    border: 1px solid var(--border);
    border-radius: 8px;
    padding: 8px 10px;
    text-align: center;
    transition: all 0.3s ease;
  }

  .stat-item:hover {
    background: #f3f4f6;
    transform: translateY(-2px);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  }

  .stat-icon {
    display: block;
    color: var(--primary);
    font-size: 1.1rem;
    margin-bottom: 4px;
    opacity: 0.8;
  }

  .stat-item span {
    font-size: 12px;
    color: var(--muted);
    display: block;
  }

  .stat-item strong {
    font-size: 14px;
    font-weight: 700;
    color: var(--text);
    display: block;
  }

  /* === Footer Layout === */
  .website-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid var(--border);
    padding-top: 10px;
    margin-top: 10px;
    flex-wrap: wrap;
    gap: 10px;
  }

  /* Domain and status section */
  .domain-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .website-domain {
    font-size: 13px;
    color: var(--text);
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
  }

  /* Connection Status Styles */
  .domain-status {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 12.5px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 8px;
    transition: all 0.3s ease;
  }

  .domain-status i {
    font-size: .6rem;
  }

  /* Status Color Codes */
  .domain-status.connected {
    background: #dcfce7;
    color: #166534;
    border: 1px solid #bbf7d0;
  }

  .domain-status.pending {
    background: #fef3c7;
    color: #92400e;
    border: 1px solid #fde68a;
  }

  .domain-status.disconnected {
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #fecaca;
  }

  /* Hover Effects */
  .domain-status:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  }

  .website-actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .website-actions i {
    font-size: 1.2rem;
    color: var(--muted);
    cursor: pointer;
    transition: all 0.25s ease;
  }

  .website-actions i:hover {
    color: var(--primary);
    transform: scale(1.1);
  }

  /* 📱 RESPONSIVE FIXES FOR MY BOOKINGS / WEBSITES PAGE */

  /* 🖥️ Tablet (≤1024px) */
  @media (max-width: 1024px) {
    .kpi-summary {
      grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)) !important;
      gap: 12px !important;
    }

    .filter-row {
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 10px !important;
    }

    .search-box {
      width: 100% !important;
    }

    .btn-primary {
      width: 100% !important;
      justify-content: center !important;
    }

    .website-grid {
      grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)) !important;
      gap: 16px !important;
    }

    .website-card {
      min-width: 100% !important;
    }
  }

  /* 📱 Mobile (≤768px) */
  @media (max-width: 768px) {
    .content {
      padding: 16px !important;
    }

    .kpi-summary {
      grid-template-columns: 1fr 1fr !important;
      gap: 10px !important;
    }

    .kpi-item {
      flex-direction: column !important;
      align-items: flex-start !important;
      padding: 14px !important;
    }

    .filter-row {
      flex-direction: column !important;
      gap: 10px !important;
      align-items: stretch !important;
    }

    .search-box {
      width: 100% !important;
      padding: 8px 12px !important;
    }

    .btn-primary {
      width: 100% !important;
      justify-content: center !important;
      font-size: 0.95rem !important;
      padding: 0.8rem 1rem !important;
    }

    .website-grid {
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: 16px !important;
    }

    .website-card {
      width: 100% !important;
      padding: 12px !important;
    }

    .website-card-header h4 {
      font-size: 1rem !important;
    }

    .website-card-body p {
      font-size: 0.9rem !important;
    }

    .website-stats-grid {
      grid-template-columns: 1fr 1fr !important;
    }

    .website-card-footer {
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 10px !important;
    }

    .domain-wrapper {
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 6px !important;
    }

    .pagination-row {
      flex-direction: column !important;
      align-items: center !important;
      gap: 10px !important;
    }

    .pagination-info {
      text-align: center !important;
      font-size: 0.85rem !important;
    }

    .pagination-buttons {
      display: flex !important;
      flex-wrap: wrap !important;
      justify-content: center !important;
      gap: 6px !important;
    }
  }

  /* 📱 Small Mobile (≤480px) */
  @media (max-width: 480px) {
    .kpi-summary {
      grid-template-columns: 1fr !important;
    }

    .filter-row {
      flex-direction: column !important;
      align-items: stretch !important;
    }

    .search-box input {
      font-size: 0.9rem !important;
    }

    .website-card {
      padding: 10px !important;
    }

    .website-card-header h4 {
      font-size: 0.95rem !important;
    }

    .website-card-body p {
      font-size: 0.85rem !important;
    }

    .stat-item {
      padding: 6px !important;
    }

    .stat-item span {
      font-size: 0.75rem !important;
    }

    .stat-item strong {
      font-size: 0.85rem !important;
    }

    .btn-primary {
      font-size: 0.85rem !important;
      padding: 0.7rem 1rem !important;
    }

    .pagination-info {
      font-size: 0.8rem !important;
    }

    .pagination-buttons button {
      font-size: 0.8rem !important;
      padding: 5px 8px !important;
    }
  }

  .btn-copy {
    background: var(--primary);
    color: #fff;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: all 0.3s ease;
  }

  .btn-copy:hover {
    background: #1e3a8a;
    transform: translateY(-1px);
  }

  /* ===== Overlay (Center Screen) ===== */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    backdrop-filter: blur(2px);

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 9999;
  }

  /* ===== Popup Box ===== */
  .modal-box {
    width: 420px;
    max-width: 90%;
    background: #fff;

    border-radius: var(--radius);
    border: 1px solid var(--border);

    padding: 24px;

    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.25);

    animation: popupFade 0.25s ease-out;
  }

  /* ===== Popup Title ===== */
  .modal-box h3 {
    margin: 0 0 15px 0;
    font-size: 18px;
    font-weight: 700;
    color: var(--text);
  }

  /* ===== Input Field ===== */
  .input-theme {
    width: 100%;
    padding: 12px 14px;
    border-radius: var(--radius);
    border: 1px solid var(--border);

    font-size: 14px;
    color: var(--text);

    background: #fff;

    transition: all 0.2s ease;
  }

  .input-theme:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 2px rgba(var(--primary-rgb), 0.15);
  }

  /* ===== Label ===== */
  .field-label {
    display: block;
    margin-bottom: 6px;
    margin-top: 6px;
    font-size: 14px;
    font-weight: 600;
    color: var(--text);
  }

  /* ===== Action Buttons Footer ===== */
  .modal-actions {
    margin-top: 22px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  /* ===== Small Chip Buttons ===== */
  .chip.small {
    padding: 6px 10px;
    font-size: 12px;
    border-radius: 20px;
    border: 1px solid var(--border);
    cursor: pointer;
  }

  /* Delete button style */
  .chip.red {
    background: #ffeaea;
    border-color: #fdc7c7;
    color: #d40000;
  }

  /* ===== Primary Save Button ===== */
  .btn-primary {
    display: flex;
    align-items: center;
    gap: 8px;

    padding: 10px 18px;
    border-radius: var(--radius);

    background: var(--primary);
    color: #fff;

    border: none;
    cursor: pointer;

    font-size: 14px;
    font-weight: 600;

    transition: 0.2s;
  }

  .btn-primary:hover {
    background: var(--primary-dark);
    transform: translateY(-1px);
  }

  /* Animation */
  @keyframes popupFade {
    from {
      opacity: 0;
      transform: translateY(-15px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>